import React, { useRef } from "react";

import useError from "@hooks/useError";
import useStores from "@hooks/useStores";

import TextField from "@components/Global/Custom/TextField";
import Button from "@components/Global/Custom/Form/Button";

import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const SignupZipcode = () => {
	const { proSignupFunnelModalStore, signupZipcodeStore: store } = useStores();
	const [ErrorTemplate, onError] = useError();

	const zipcodeRef = useRef();
	const nextHandler = () => {
		try {
			store.updateZipcode(zipcodeRef.current.value);
		} catch (err) {
			onError(err);
		}
	};

	return (
		<React.Fragment>
			<DialogTitle id="scroll-dialog-title">
				Subscribe
				<IconButton
					aria-label="close"
					style={{ position: "absolute", top: 8, right: 8, color: "grey.500" }}
					onClick={() => proSignupFunnelModalStore.onClose()}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<TextField
					ref={zipcodeRef}
					pattern="\d*"
					placeholder="Zip code"
					label={"Please confirm where you are located"}
				/>
				<br />
				<br />
				<br />
				<ErrorTemplate />
				<Button onClick={nextHandler} className={"btn-blue btn-text"}>
					Next
				</Button>
			</DialogContent>
		</React.Fragment>
	);
};

export default SignupZipcode;
